export default (params) => ({
  trigger: {
    name: 'order_block.send_lease_request',
    params: params,
  },
  config: {
    schema: {
      unique_id: {
        type: 'string',
      },
    },
    event: {
      name: 'send',
      params: {
        sub_feature: 'lease_quote',
        id_type: 'lease_correlation_id',
        content_type: null,
      },
    },
  },
});
